import { composeRenderProps } from "react-aria-components";
import { twMerge } from "tailwind-merge";

export function composeTailwindRenderProps<T>(
  className: string | ((v: T) => string) | undefined,
  tw: string,
): (v: T) => string {
  return composeRenderProps(className, (className) => twMerge(tw, className));
}

export function getAbbreviationFromAlt(alt: string): string {
  let abbreviation = "";
  alt.split(" ").forEach((string) => {
    abbreviation += string?.charAt(0)?.toUpperCase();
  });

  return abbreviation.slice(0, 2);
}
